import { render, staticRenderFns } from "./GiftCardBlock.vue?vue&type=template&id=7c2da97b&scoped=true&"
import script from "./GiftCardBlock.vue?vue&type=script&lang=ts&"
export * from "./GiftCardBlock.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCardBlock.vue?vue&type=style&index=0&id=7c2da97b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2da97b",
  null
  
)

export default component.exports